<template>
  <div>
    <Customer_point_list/>
  </div>
</template>

<script>
import Customer_point_list from "@/components/adminArin/pos_system/customerpoint/Customer_point_list";
export default {
  name: "customerpointlist",
  components: {
    Customer_point_list
  }
}
</script>

<style scoped>

</style>
